export default __webpack_public_path__ + "static/media/gridPlusWallet.b4f47325.png";